import { Grid, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { useCountdown } from '../../../../hooks/useCountdown'
import { Achievement } from '../../../RewardService/types'
import { ClaimedReward } from './ClaimedReward'

type AchievementCardProps = {
    achievement: Achievement
}

export const AchievementCard: FC<AchievementCardProps> = ({ achievement }) => {
    const [hidden, setHidden] = useState(false)

    const timeLeft = useCountdown(achievement.expirationDate, () => {
        achievement.expirationDate && !hidden && setHidden(true)
    })

    if (hidden) return null

    return (
        <Grid sx={{ maxWidth: '200px !important' }} item xs={4} sm={3} md={2} lg={2} key={achievement.challengeId}>
            <ClaimedReward reward={achievement} animated={Boolean(achievement.isNew)} />
            <Typography variant="body2" textAlign="center" width="100%" fontWeight="bold" sx={{ mt: 1 }}>
                {achievement.tooltip}
            </Typography>
            {timeLeft && (
                <Typography color="text.disabled" variant="body2" textAlign="center" fontWeight="bold" sx={{ mt: 0.5 }}>
                    EXPIRES: {timeLeft}
                </Typography>
            )}
        </Grid>
    )
}
